import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-data-visualisation',
  templateUrl: './data-visualisation.component.html',
  styleUrls: ['./data-visualisation.component.scss']
})
export class DataVisualisationComponent implements OnInit {

  exposition: CardContent = {
    title: 'Data Visualisation',
    image_source: 'assets/images/HorizonBanner.png',
  };

  horizon: CardContent = {
    title: 'Horizon Diagram',
    image_source: 'assets/images/HorizonBanner.png',
  };

  stream: CardContent = {
    title: 'Stream Chart',
    image_source: 'assets/images/Stream.PNG',
  };

  chord: CardContent = {
    title: 'Chord Diagram',
    image_source: 'assets/images/Chord.PNG',
  };

  heatmap: CardContent = {
    title: 'Heatmap',
    image_source: 'assets/images/Heatmap.PNG',
  };
  constructor() { }

  ngOnInit(): void {
  }

}
